module.exports = __webpack_public_path__ + "static/media/clone.9a31ac14.svg";